export const readFileContent = (file: File) => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener(
            "load",
            () => {
                resolve(reader.result as string);
            },
            false,
        );
        reader.addEventListener(
            "error",
            (error) => reject(error),
            false,
        );
        reader.readAsText(file);
    });
};
